import {InjectSearchOverlay} from '@components';
import {Interceptor} from '@jobseeker/common-core/components';
import {NavLayout, SeoLayout} from '@layouts';
import {metaInfo} from '@configs';
import {getConfigByApp} from '@utils';
import {HOME, JOBFEED} from '@constants';
import {shallowEqual, useSelector} from 'react-redux';
import {AppState} from '@jobseeker/common-core/types';
import {AppleCallback} from '@jobseeker/feature-authentication/components';
import {GetServerSideProps} from 'next';

type CallBackProps = {
  seoConfig: object;
  code?: string;
  state?: string;
};

const AppleAuthCallback = ({seoConfig, code, state}: CallBackProps) => {
  const metaData = getConfigByApp(metaInfo, HOME, true, JOBFEED);
  const isSearchEnabled = useSelector(
    (state: AppState) => state.app.layout.searchOverlay,
    shallowEqual
  );

  return (
    <Interceptor metaInfo={metaData}>
      <SeoLayout seoConfig={seoConfig} />
      <NavLayout>
        <InjectSearchOverlay isSearchEnabled={isSearchEnabled} />
        <AppleCallback code={code} state={state} />
      </NavLayout>
    </Interceptor>
  );
};

export const getServerSideProps: GetServerSideProps = async context => {
  const {req} = context;

  // Apple POSTs form_post data — parse the body
  if (req.method === 'POST') {
    const body = await new Promise<Record<string, string>>(resolve => {
      let raw = '';
      req.on('data', chunk => {
        raw += chunk;
      });
      req.on('end', () => {
        const parsed: Record<string, string> = {};
        new URLSearchParams(raw).forEach((v, k) => {
          parsed[k] = v;
        });
        resolve(parsed);
      });
    });

    const code = body.code ?? null;
    const state = body.state ?? null;

    return {props: {code: code ?? '', state: state ?? ''}};
  }

  // Fallback for direct GET access
  return {props: {code: '', state: ''}};
};

export default AppleAuthCallback;
